/*
  Fizinga Clean theme scripts. No libraries.
  Each feature looks for its own data-* attribute, so removing a section never breaks another.
*/
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, cartType: 'drawer' };
  var CART_SECTION = 'cart-drawer';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function emit(name, target) {
    (target || document).dispatchEvent(new CustomEvent(name, { bubbles: true }));
  }

  /* ------------------------------------------------------------------
     Drawers (mobile menu and cart)
  ------------------------------------------------------------------ */
  var lastFocused = null;

  function openDrawer(id, opener) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocused = opener || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[aria-controls="' + id + '"]').forEach(function (el) {
      el.setAttribute('aria-expanded', 'true');
    });
    var panel = $('.drawer__panel', drawer);
    if (panel) window.setTimeout(function () { panel.focus(); }, 60);
    if (id === 'CartDrawer') emit('cart:open');
  }

  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (el) {
      el.setAttribute('aria-expanded', 'false');
    });
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'), opener);
      return;
    }

    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('[data-drawer]'));
      return;
    }

    var cartLink = event.target.closest('[data-cart-open]');
    if (cartLink && theme.cartType === 'drawer' && !document.body.classList.contains('template-cart')) {
      event.preventDefault();
      openDrawer('CartDrawer', cartLink);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      $$('.drawer.is-open').forEach(closeDrawer);
      $$('[data-predictive-results]').forEach(function (el) { el.hidden = true; });
      return;
    }

    // Keep keyboard focus inside an open drawer
    if (event.key !== 'Tab') return;
    var drawer = $('.drawer.is-open');
    if (!drawer) return;
    var focusable = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', drawer)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ------------------------------------------------------------------
     Cart: add, change, re-render the drawer
  ------------------------------------------------------------------ */
  function updateCartCount(count) {
    var n = parseInt(count, 10) || 0;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function renderCartDrawer(sections) {
    var html = sections && sections[CART_SECTION];
    if (!html) return refreshCartDrawer();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawerInner');
    var current = document.getElementById('CartDrawerInner');
    if (fresh && current) {
      current.replaceWith(fresh);
      updateCartCount(fresh.getAttribute('data-cart-count-value'));
    }
    return Promise.resolve();
  }

  function refreshCartDrawer() {
    return fetch(window.location.pathname + '?sections=' + CART_SECTION)
      .then(function (res) { return res.json(); })
      .then(function (sections) { return renderCartDrawer(sections); })
      .catch(function () {});
  }

  function showError(container, message) {
    if (!container) return;
    container.textContent = message;
    container.hidden = false;
    window.setTimeout(function () { container.hidden = true; }, 6000);
  }

  // Remember which submit button was pressed (older Safari has no event.submitter)
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('button[type="submit"]');
    if (btn && btn.form) btn.form._submitter = btn;
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;

    var submitter = event.submitter || form._submitter;
    // "Buy now" is normally taken over by GoKwik. If GoKwik is off, add the item and go to checkout.
    var buyNow = !!(submitter && submitter.name === 'buy_now');
    if (!buyNow && theme.cartType !== 'drawer') return;

    event.preventDefault();
    var button = submitter || $('[name="add"]', form);
    var errorBox = $('.form-error', form);
    if (button) button.classList.add('is-loading');

    var body = new FormData(form);
    body.delete('buy_now');
    if (!buyNow) {
      body.append('sections', CART_SECTION);
      body.append('sections_url', window.location.pathname);
    }

    fetch((theme.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw data;
          return data;
        });
      })
      .then(function (data) {
        if (buyNow) {
          window.location.href = '/checkout';
          return;
        }
        // On the cart page itself, reload so the page shows the new line
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        return renderCartDrawer(data.sections).then(function () {
          openDrawer('CartDrawer', button);
          emit('cart:refresh');
        });
      })
      .catch(function (error) {
        showError(errorBox, (error && (error.description || error.message)) || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        if (button) button.classList.remove('is-loading');
      });
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-line-change]');
    if (!trigger) return;
    event.preventDefault();

    var line = parseInt(trigger.getAttribute('data-line-change'), 10);
    var quantity = Math.max(0, parseInt(trigger.getAttribute('data-quantity'), 10) || 0);
    var onCartPage = !!trigger.closest('[data-cart-page]');
    var row = trigger.closest('.cart-line');
    if (row) row.classList.add('is-updating');

    fetch((theme.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: [CART_SECTION],
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw data;
          return data;
        });
      })
      .then(function (data) {
        if (onCartPage) {
          window.location.reload();
          return;
        }
        renderCartDrawer(data.sections).then(function () {
          var panel = $('#CartDrawer .drawer__panel');
          if (panel) panel.focus();
          emit('cart:refresh');
        });
      })
      .catch(function (error) {
        if (row) row.classList.remove('is-updating');
        var message = (error && (error.description || error.message)) || 'Could not update the cart.';
        var box = document.createElement('p');
        box.className = 'form-error';
        box.setAttribute('role', 'alert');
        if (row && row.parentNode) {
          row.parentNode.insertBefore(box, row.nextSibling);
          showError(box, message);
        }
      });
  });

  /* ------------------------------------------------------------------
     Sliders (hero, product rails, gallery, videos, testimonials)
  ------------------------------------------------------------------ */
  function initSlider(root) {
    if (root._sliderReady) return;
    var track = $('[data-slider-track]', root);
    if (!track) return;
    root._sliderReady = true;

    var prev = $('[data-slider-prev]', root);
    var next = $('[data-slider-next]', root);
    var dots = $('[data-slider-dots]', root);
    var ticking = false;

    function slides() {
      return Array.prototype.slice.call(track.children);
    }

    function gap() {
      return parseFloat(window.getComputedStyle(track).columnGap) || 0;
    }

    function step() {
      var first = slides()[0];
      return first ? first.getBoundingClientRect().width + gap() : track.clientWidth;
    }

    function currentIndex() {
      var s = step();
      return s ? Math.round(track.scrollLeft / s) : 0;
    }

    function update() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      var index = currentIndex();
      if (dots) {
        Array.prototype.forEach.call(dots.children, function (dot, n) {
          dot.classList.toggle('is-active', n === index);
        });
      }
      root.dispatchEvent(new CustomEvent('slider:change', { detail: { index: index } }));
    }

    function goTo(index) {
      var list = slides();
      if (!list.length) return;
      var target = list[Math.max(0, Math.min(index, list.length - 1))];
      track.scrollTo({ left: target.offsetLeft - list[0].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function page(direction) {
      var s = step();
      var perView = Math.max(1, Math.floor((track.clientWidth + gap()) / s));
      track.scrollBy({ left: direction * perView * s, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    if (dots) {
      Array.prototype.forEach.call(dots.children, function (dot, n) {
        dot.addEventListener('click', function () { goTo(n); });
      });
    }

    track.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });

    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();

    // Auto-rotate (banner slider)
    var delay = parseInt(root.getAttribute('data-autoplay'), 10);
    if (delay && !reduceMotion && slides().length > 1) {
      var paused = false;
      var timer = window.setInterval(function () {
        if (paused || document.hidden) return;
        var index = currentIndex() + 1;
        goTo(index >= slides().length ? 0 : index);
      }, delay);
      ['pointerenter', 'focusin', 'touchstart'].forEach(function (name) {
        root.addEventListener(name, function () { paused = true; }, { passive: true });
      });
      ['pointerleave', 'focusout'].forEach(function (name) {
        root.addEventListener(name, function () { paused = false; });
      });
      root._stopAutoplay = function () { window.clearInterval(timer); };
    }

    root._goTo = goTo;
    root._update = update;
  }

  /* ------------------------------------------------------------------
     Tabs in product sliders
  ------------------------------------------------------------------ */
  function initTabs(root) {
    var tabs = $$('[data-tab]', root);
    if (tabs.length < 2) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (other) {
          var active = other === tab;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-selected', active ? 'true' : 'false');
          var panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        var shown = document.getElementById(tab.getAttribute('aria-controls'));
        if (shown) {
          $$('[data-slider]', shown).forEach(function (slider) {
            if (slider._update) slider._update();
          });
        }
        // Lets the GoKwik script pick up "Buy now" buttons that were hidden until now
        emit('cart:refresh');
      });
    });
  }

  /* ------------------------------------------------------------------
     Product page: variants, gallery thumbnails, quantity, sticky bar
  ------------------------------------------------------------------ */
  function initProduct(root) {
    if (root._productReady) return;
    root._productReady = true;

    var dataEl = $('[data-product-json]', root);
    var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    var gallery = $('[data-gallery]', root);
    var thumbs = gallery ? $$('[data-thumb-index]', gallery) : [];

    if (gallery) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (gallery._goTo) gallery._goTo(parseInt(thumb.getAttribute('data-thumb-index'), 10));
        });
      });
      gallery.addEventListener('slider:change', function (event) {
        thumbs.forEach(function (thumb, n) {
          thumb.classList.toggle('is-active', n === event.detail.index);
        });
        var active = thumbs[event.detail.index];
        if (active && active.parentElement) {
          active.parentElement.scrollTo({ left: active.offsetLeft - 40, behavior: 'smooth' });
        }
      });
    }

    var picker = $('[data-variant-picker]', root);
    if (picker) {
      picker.addEventListener('change', function () {
        var selected = [];
        $$('input[data-option-index]:checked', picker).forEach(function (input) {
          selected[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
        });
        selected.forEach(function (value, i) {
          var label = $('[data-option-value="' + i + '"]', picker);
          if (label) label.textContent = value;
        });

        var variant = data.variants.filter(function (v) {
          return v.options.every(function (option, i) { return option === selected[i]; });
        })[0];

        var addButtons = $$('[data-add-button]', root);
        var buyButtons = $$('[data-buy-button]', root);

        if (!variant) {
          addButtons.forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; });
          buyButtons.forEach(function (b) { b.disabled = true; });
          return;
        }

        $$('[data-variant-id]', root).forEach(function (input) { input.value = variant.id; });

        var price = $('[data-price] .price', root);
        if (price) price.outerHTML = variant.price_html;
        var stickyPrice = $('[data-sticky-price]', root);
        if (stickyPrice) stickyPrice.innerHTML = variant.price_html_small;

        addButtons.forEach(function (b) {
          b.disabled = !variant.available;
          b.textContent = variant.available ? 'Add to cart' : 'Sold out';
        });
        buyButtons.forEach(function (b) { b.disabled = !variant.available; });

        if (variant.media_id && gallery && gallery._goTo) {
          var slides = $$('[data-media-id]', gallery);
          for (var i = 0; i < slides.length; i++) {
            if (String(slides[i].getAttribute('data-media-id')) === String(variant.media_id)) {
              gallery._goTo(i);
              break;
            }
          }
        }

        var url = root.getAttribute('data-url');
        if (url && window.history.replaceState) {
          window.history.replaceState({}, '', url + '?variant=' + variant.id);
        }
      });
    }

    // Quantity stepper on the product page
    $$('[data-qty-input]', root).forEach(function (wrap) {
      var input = $('input', wrap);
      var stickyQty = $('[data-sticky-qty]', root);
      wrap.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-qty-step]');
        if (!btn) return;
        var value = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10);
        input.value = Math.max(1, value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      input.addEventListener('change', function () {
        if (stickyQty) stickyQty.value = Math.max(1, parseInt(input.value, 10) || 1);
      });
    });

    // Sticky buy bar appears once the main buttons scroll out of view
    var sticky = $('[data-sticky-buy]', root);
    var mainBuy = $('[data-main-buy]', root);
    if (sticky && sticky.hasAttribute('data-sticky-always')) {
      document.body.classList.add('has-sticky-buy');
    } else if (sticky && mainBuy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('has-sticky-buy', show);
        $$('button, input:not([type="hidden"])', sticky).forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      }).observe(mainBuy);
    }
  }

  /* ------------------------------------------------------------------
     Frequently bought together: live total + add everything ticked
  ------------------------------------------------------------------ */
  function initBundle(root) {
    if (root._ready) return;
    root._ready = true;
    var prefix = root.getAttribute('data-money-prefix') || '';
    var totalEl = $('[data-bundle-total]', root);
    var button = $('[data-bundle-add]', root);
    var errorBox = $('.form-error', root);

    function selected() {
      return $$('[data-bundle-item]:checked', root);
    }

    function updateTotal() {
      var total = parseInt($('[data-bundle-main]', root).getAttribute('data-price'), 10) || 0;
      selected().forEach(function (box) { total += parseInt(box.getAttribute('data-price'), 10) || 0; });
      if (totalEl) totalEl.textContent = prefix + (total / 100).toLocaleString('en-US', { maximumFractionDigits: 2 });
    }

    root.addEventListener('change', updateTotal);
    updateTotal();

    if (!button) return;
    button.addEventListener('click', function () {
      var product = root.closest('[data-product]');
      var mainId = product && $('[data-main-buy] [data-variant-id]', product);
      var items = [];
      if (mainId) items.push({ id: parseInt(mainId.value, 10), quantity: 1 });
      selected().forEach(function (box) {
        items.push({ id: parseInt(box.getAttribute('data-variant-id'), 10), quantity: 1 });
      });
      if (!items.length) return;
      button.classList.add('is-loading');

      fetch((theme.routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: [CART_SECTION], sections_url: window.location.pathname })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || data.status) throw data;
            return data;
          });
        })
        .then(function (data) {
          if (theme.cartType !== 'drawer') {
            window.location.href = theme.routes.cart || '/cart';
            return;
          }
          return renderCartDrawer(data.sections).then(function () {
            openDrawer('CartDrawer', button);
            emit('cart:refresh');
          });
        })
        .catch(function (error) {
          showError(errorBox, (error && (error.description || error.message)) || 'Could not add to cart. Please try again.');
        })
        .finally(function () {
          button.classList.remove('is-loading');
        });
    });
  }

  /* ------------------------------------------------------------------
     Predictive search in the header
  ------------------------------------------------------------------ */
  function initPredictiveSearch(form) {
    var input = $('input[name="q"]', form);
    var results = $('[data-predictive-results]', form);
    if (!input || !results || !theme.routes.predictiveSearch) return;
    var timer = null;
    var controller = null;

    function close() {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function search(term) {
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = theme.routes.predictiveSearch +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,page,article' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&section_id=predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var inner = doc.querySelector('[data-predictive-inner]');
          if (!inner || input.value.trim() !== term) return;
          results.innerHTML = '';
          results.appendChild(inner);
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      var term = input.value.trim();
      if (term.length < 2) {
        close();
        return;
      }
      timer = window.setTimeout(function () { search(term); }, 220);
    });

    input.addEventListener('focus', function () {
      if (results.innerHTML.trim() && input.value.trim().length >= 2) {
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) close();
    });
  }

  /* ------------------------------------------------------------------
     Announcement bar rotation
  ------------------------------------------------------------------ */
  function initAnnouncement(root) {
    var items = $$('.announcement__item', root);
    if (items.length < 2 || reduceMotion || root._ready) return;
    root._ready = true;
    var index = 0;
    var delay = (parseInt(root.getAttribute('data-interval'), 10) || 4) * 1000;
    window.setInterval(function () {
      if (document.hidden || root.matches(':hover')) return;
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, delay);
  }

  /* ------------------------------------------------------------------
     Shoppable videos: play while on screen, tap for sound
  ------------------------------------------------------------------ */
  function initReels(root) {
    if (root._ready) return;
    root._ready = true;
    var videos = $$('[data-reel-video]', root);
    if (!videos.length) return;

    if ('IntersectionObserver' in window && !reduceMotion && !saveData) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.6 });
      videos.forEach(function (video) { observer.observe(video); });
    }

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-reel-sound]');
      if (!btn) return;
      var video = $('video', btn.parentElement);
      if (!video) return;
      var turnOn = video.muted;
      videos.forEach(function (other) {
        if (other !== video) {
          other.muted = true;
          var otherBtn = $('[data-reel-sound]', other.parentElement);
          if (otherBtn) otherBtn.classList.remove('is-on');
        }
      });
      video.muted = !turnOn;
      btn.classList.toggle('is-on', turnOn);
      btn.setAttribute('aria-label', turnOn ? 'Turn sound off' : 'Turn sound on');
      if (turnOn) {
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      }
    });
  }

  /* ------------------------------------------------------------------
     "You may also like" (loads when it comes near the screen)
  ------------------------------------------------------------------ */
  function initRecommendations(el) {
    if (el._ready || !el.getAttribute('data-url')) return;
    el._ready = true;

    function load() {
      fetch(el.getAttribute('data-url'))
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            initAll(el);
          }
        })
        .catch(function () {});
    }

    if (!('IntersectionObserver' in window)) return load();
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      load();
    }, { rootMargin: '500px 0px' });
    observer.observe(el);
  }

  /* ------------------------------------------------------------------
     Order receipt on our own site (/pages/order-placed)
     GoKwik runs checkout in its own frame and messages this page when an
     order is placed. We keep a small copy in this browser only (no name,
     phone or address) and show it on the "Order placed" page.
  ------------------------------------------------------------------ */
  var ORDER_KEY = 'fz_last_order';
  var CHECKOUT_KEY = 'fz_checkout_items';
  var RECEIPT_PATH = '/pages/order-placed';
  var RECENT = 15 * 60 * 1000;

  function store(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }

  function cleanItems(items) {
    return (Array.isArray(items) ? items : []).map(function (i) {
      var img = i.image || (i.featured_image && (i.featured_image.url || i.featured_image)) || '';
      var price = typeof i.final_line_price === 'number' ? i.final_line_price : i.line_price;
      return {
        title: String(i.product_title || i.title || ''),
        variant: i.variant_title && i.variant_title !== 'Default Title' ? String(i.variant_title) : '',
        qty: parseInt(i.quantity, 10) || 1,
        price: typeof price === 'number' ? price : null,
        image: typeof img === 'string' ? img : '',
        url: typeof i.url === 'string' ? i.url : '',
        handle: String(i.handle || '')
      };
    }).filter(function (i) { return i.title; });
  }

  function snapshotCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = cleanItems(cart.items);
        if (items.length) store(CHECKOUT_KEY, { at: Date.now(), items: items });
      })
      .catch(function () {});
  }

  function snapshotBuyNow(form) {
    var idInput = $('[name="id"]', form);
    var qtyInput = $('[name="quantity"]', form);
    var holder = form.closest('[data-product]') || form.closest('[data-product-card]');
    if (!idInput || !holder) return;
    var link = $('a[href*="/products/"]', holder);
    var url = holder.getAttribute('data-url') || (link && link.getAttribute('href'));
    if (!url) return;
    var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
    fetch(url.split('?')[0] + '.js')
      .then(function (res) { return res.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return String(x.id) === String(idInput.value); })[0] || p.variants[0];
        store(CHECKOUT_KEY, {
          at: Date.now(),
          items: [{
            title: p.title,
            variant: v && v.public_title ? v.public_title : '',
            qty: qty,
            price: v ? v.price * qty : null,
            image: (v && v.featured_image && v.featured_image.src) || p.featured_image || '',
            url: p.url,
            handle: p.handle
          }]
        });
      })
      .catch(function () {});
  }

  // GoKwik stops "click" from reaching us, so watch the press instead
  document.addEventListener('pointerdown', function (event) {
    var btn = event.target.closest && event.target.closest('button, a');
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    var fn = String(btn.getAttribute('data-gokwik-function') || '').toLowerCase();
    if (btn.name === 'buy_now' || fn === 'buynow') {
      if (form) snapshotBuyNow(form);
    } else if (btn.name === 'checkout' || btn.classList.contains('gokwik-marge')) {
      snapshotCart();
    }
  }, true);

  function findOrder(obj, depth) {
    if (!obj || typeof obj !== 'object' || depth > 4) return null;
    if (obj.orderName || obj.order_name) return obj;
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
      var found = findOrder(obj[keys[i]], depth + 1);
      if (found) return found;
    }
    return null;
  }

  function pendingOrder() {
    var order = read(ORDER_KEY);
    return order && !order.shown && Date.now() - order.at < RECENT ? order : null;
  }

  function saveOrder(info) {
    var order = pendingOrder() || { at: Date.now(), items: [] };
    info = info || {};
    order.name = String(info.orderName || info.order_name || order.name || '');
    var total = info.finalPayablePrice || info.totalValue || (info.commonAnalyticsData && info.commonAnalyticsData.cart_after_discount);
    if (total && !isNaN(parseFloat(total))) order.total = Math.round(parseFloat(total) * 100);
    if (info.paymentMethod) order.payment = String(info.paymentMethod);
    if (typeof info.thankYouPageUrl === 'string' && /^https:\/\//.test(info.thankYouPageUrl)) order.statusUrl = info.thankYouPageUrl;
    var items = cleanItems(info.cart && info.cart.items);
    if (items.length) order.items = items;
    if (!order.items.length) {
      var snap = read(CHECKOUT_KEY);
      if (snap && Date.now() - snap.at < 2 * 60 * 60 * 1000) order.items = snap.items;
    }
    store(ORDER_KEY, order);
    return order;
  }

  function goToReceipt() {
    if (window.location.pathname.indexOf(RECEIPT_PATH) === 0) return;
    window.location.href = RECEIPT_PATH;
  }

  window.addEventListener('message', function (event) {
    var host = '';
    try { host = new URL(event.origin).hostname; } catch (e) { return; }
    if (!/(^|\.)gokwik\.(co|io|in)$/.test(host)) return;
    var data = event.data;
    if (data === 'order_create_success') data = { type: 'orderSuccess' };
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch (e) { return; }
    }
    if (!data || typeof data !== 'object') return;

    var info = findOrder(data, 0);
    if (data.type === 'orderSuccess' || info) {
      saveOrder(info || data.response);
      // the cart is still full for a moment after the order, so use it if GoKwik sent no items
      if (!read(ORDER_KEY).items.length) {
        fetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) {
          var order = pendingOrder();
          if (order && !order.items.length) {
            order.items = cleanItems(cart.items);
            store(ORDER_KEY, order);
          }
        }).catch(function () {});
      }
      return;
    }

    if (!pendingOrder()) return;
    // After the order GoKwik sends the shopper to its thank-you page: bring them to ours instead
    if (data.type === 'redirect' && /orders\/|thank[_-]?you/i.test(String(data.url || ''))) {
      var order = pendingOrder();
      if (/^https:\/\//.test(String(data.url))) {
        order.statusUrl = String(data.url);
        store(ORDER_KEY, order);
      }
      window.setTimeout(goToReceipt, 0);
    } else if (data.type === 'close') {
      window.setTimeout(goToReceipt, 300);
    }
  });

  function initReceipt(root) {
    if (root._ready) return;
    root._ready = true;
    var order = read(ORDER_KEY);
    if (!order || Date.now() - order.at > 24 * 60 * 60 * 1000) return;
    if (!order.shown) {
      order.shown = true;
      store(ORDER_KEY, order);
    }

    var prefix = root.getAttribute('data-money-prefix') || '₹';
    function money(paise) {
      var value = paise / 100;
      return prefix + value.toLocaleString('en-IN', { minimumFractionDigits: value % 1 ? 2 : 0, maximumFractionDigits: 2 });
    }
    function text(selector, value) {
      var el = $(selector, root);
      if (el && value) {
        el.textContent = value;
        el.closest('[data-receipt-row]') && (el.closest('[data-receipt-row]').hidden = false);
      }
    }

    var payments = { cod: 'Cash on delivery', upi: 'UPI', card: 'Card', netbanking: 'Net banking', wallet: 'Wallet', emi: 'EMI', ppcod: 'Part-paid COD' };
    var pay = order.payment ? (payments[String(order.payment).toLowerCase().replace(/[^a-z]/g, '')] || order.payment) : '';
    text('[data-receipt-name]', order.name);
    text('[data-receipt-pay]', pay);

    var list = $('[data-receipt-items]', root);
    var sum = 0;
    (order.items || []).forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'receipt__item';
      var media = document.createElement('span');
      media.className = 'receipt__img';
      if (item.image) {
        var img = document.createElement('img');
        var src = item.image.indexOf('//') === 0 ? 'https:' + item.image : item.image;
        if (src.indexOf('cdn.shopify.com') !== -1 || src.indexOf('/cdn/shop/') !== -1) {
          src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';
        }
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        media.appendChild(img);
      }
      var qty = document.createElement('span');
      qty.className = 'receipt__qty';
      qty.textContent = item.qty;
      media.appendChild(qty);
      var info = document.createElement('span');
      info.className = 'receipt__info';
      var name = document.createElement('span');
      name.className = 'receipt__name';
      name.textContent = item.title.split(' | ')[0];
      info.appendChild(name);
      if (item.variant) {
        var variant = document.createElement('span');
        variant.className = 'receipt__variant';
        variant.textContent = item.variant;
        info.appendChild(variant);
      }
      var price = document.createElement('span');
      price.className = 'receipt__price';
      if (typeof item.price === 'number') {
        price.textContent = money(item.price);
        sum += item.price;
      }
      li.appendChild(media);
      li.appendChild(info);
      li.appendChild(price);
      if (list) list.appendChild(li);
    });

    var total = order.total || sum;
    text('[data-receipt-total]', total ? money(total) : '');
    var card = $('[data-receipt-card]', root);
    if (card && (order.name || (order.items && order.items.length))) card.hidden = false;

    var track = $('[data-receipt-track]', root);
    if (track && order.statusUrl) {
      track.href = order.statusUrl;
      track.hidden = false;
    }

    // Don't suggest what was just bought
    var handles = (order.items || []).map(function (i) { return i.handle; }).filter(Boolean);

    // Trial pack bought: show the "ready for the 1 kg pack?" code
    var offer = $('[data-receipt-offer]', root);
    if (offer) {
      var trialHandles = (offer.getAttribute('data-handles') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
      var boughtTrial = handles.some(function (h) { return trialHandles.indexOf(h) !== -1; });
      if (boughtTrial) offer.hidden = false;
      var copyBtn = $('[data-copy-code]', offer);
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var code = copyBtn.getAttribute('data-copy-code');
          var label = $('[data-copy-label]', copyBtn);
          var done = function () { if (label) label.textContent = 'Copied'; };
          if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, function () {});
        });
      }
    }
    $$('[data-product-card]').forEach(function (cardEl) {
      var link = $('a[href*="/products/"]', cardEl);
      var href = link ? link.getAttribute('href') : '';
      var bought = handles.some(function (h) { return href.indexOf('/products/' + h) !== -1; });
      if (bought) (cardEl.closest('.slider-slide') || cardEl).hidden = true;
    });
  }

  /* ------------------------------------------------------------------
     Scroll effects: things glide up into place as they come on screen,
     banners settle from a slight zoom, and the top slider eases back
     as you scroll past it. Off for "reduce motion" and in the theme editor.
  ------------------------------------------------------------------ */
  var REVEAL_UP = [
    '.section-title', '.section-sub', '.section-head', '.view-all',
    '.rail__item', '.reel', '.icon-strip__item', '.steps__item', '.image-cards__item',
    '.accordion__item', '.compare__wrap', '.article-card',
    '.rich-text__heading', '.rich-text__text', '.rich-text .btn',
    '.brand-intro', '.receipt__card', '.collection-grid > *', '.grid > .card'
  ].join(',');
  var REVEAL_ZOOM = '.image-banner__media, .compare__img';
  var revealObserver = null;
  var revealEnabled = !reduceMotion && 'IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode);

  function finishReveal(el) {
    el.removeAttribute('data-reveal');
    el.classList.remove('is-in');
    el.style.removeProperty('--reveal-delay');
  }

  function initReveal(root) {
    if (!revealEnabled) return;
    if (!revealObserver) {
      document.documentElement.classList.add('reveal-on');
      // Safety net: if the observer never reports (very old browser etc.), just show everything
      var alive = false;
      window.setTimeout(function () {
        if (!alive && document.visibilityState === 'visible') document.documentElement.classList.remove('reveal-on');
      }, 3000);
      revealObserver = new IntersectionObserver(function (entries) {
        alive = true;
        var shown = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          revealObserver.unobserve(el);
          // things arriving together ripple in one after another
          el.style.setProperty('--reveal-delay', Math.min(shown, 5) * 70 + 'ms');
          shown++;
          el.classList.add('is-in');
          window.setTimeout(function () { finishReveal(el); }, 1300 + Math.min(shown, 5) * 70);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    // Inside a sideways-swiping row, moving things up/down makes the row scroll vertically on phones, so only fade there
    function inSideScroller(el) {
      for (var node = el.parentElement; node && node !== document.body; node = node.parentElement) {
        var ox = getComputedStyle(node).overflowX;
        if (ox === 'auto' || ox === 'scroll') return true;
      }
      return false;
    }
    function watch(selector, kind) {
      $$(selector, root).forEach(function (el) {
        if (el._reveal || el.closest('.hero, .drawer, .pdp__info, [data-sticky-buy]')) return;
        el._reveal = true;
        el.setAttribute('data-reveal', inSideScroller(el) ? 'fade' : kind);
        revealObserver.observe(el);
      });
    }
    watch(REVEAL_ZOOM, 'zoom');
    watch(REVEAL_UP, 'up');
  }

  function initHeroScroll() {
    var hero = $('.hero');
    if (!hero || !revealEnabled) return;
    var inner = $('.hero__viewport', hero);
    if (!inner) return;
    var ticking = false;
    function update() {
      ticking = false;
      var rect = hero.getBoundingClientRect();
      var p = Math.min(Math.max(-rect.top / (rect.height || 1), 0), 1);
      inner.style.transform = p ? 'translate3d(0,' + (p * 18).toFixed(1) + 'px,0) scale(' + (1 - p * 0.06).toFixed(4) + ')' : '';
      inner.style.opacity = p ? (1 - p * 0.45).toFixed(3) : '';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
  }

  /* ------------------------------------------------------------------
     Product information: sticky tabs that jump to each section and
     highlight the one you are reading (MuscleBlaze style)
  ------------------------------------------------------------------ */
  function initProductInfo(root) {
    if (root._ready) return;
    root._ready = true;
    var barWrap = $('[data-pinfo-bar]', root);
    var bar = barWrap && $('.pinfo__bar', barWrap);
    var links = $$('[data-pinfo-link]', root);
    if (!bar || !links.length) return;
    var cards = links.map(function (link) { return document.getElementById(link.getAttribute('href').slice(1)); });
    var current = -1;

    function offsetTop() {
      var header = $('.section-header');
      return (header ? header.offsetHeight : 0) + barWrap.offsetHeight + 8;
    }

    function setActive(index) {
      if (index === current) return;
      current = index;
      links.forEach(function (link, i) {
        link.classList.toggle('is-active', i === index);
        if (i === index) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      var link = links[index];
      if (link) {
        var left = link.offsetLeft - (bar.clientWidth - link.offsetWidth) / 2;
        bar.scrollTo({ left: Math.max(left, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    links.forEach(function (link, i) {
      link.addEventListener('click', function (event) {
        var card = cards[i];
        if (!card) return;
        event.preventDefault();
        card.open = true;
        var top = card.getBoundingClientRect().top + window.pageYOffset - offsetTop();
        window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
        setActive(i);
      });
    });

    var ticking = false;
    function spy() {
      ticking = false;
      var line = offsetTop() + 24;
      var index = 0;
      cards.forEach(function (card, i) {
        if (card && card.getBoundingClientRect().top <= line) index = i;
      });
      setActive(index);
      var wrapTop = barWrap.getBoundingClientRect().top;
      var header = $('.section-header');
      barWrap.classList.toggle('is-stuck', wrapTop <= (header ? header.offsetHeight : 0) + 1);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(spy);
      }
    }, { passive: true });
    spy();
  }

  /* ------------------------------------------------------------------
     Small things
  ------------------------------------------------------------------ */
  function initSort(root) {
    $$('[data-sort-select]', root).forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  function setHeaderHeight() {
    var header = $('.section-header');
    if (header) document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  }

  function collapseFooterOnMobile() {
    if (window.matchMedia('(max-width: 989px)').matches) {
      $$('.footer__links').forEach(function (details) { details.open = false; });
    }
  }

  function initAll(root) {
    root = root || document;
    $$('[data-slider]', root).forEach(initSlider);
    $$('[data-tabs]', root).forEach(initTabs);
    $$('[data-product]', root).forEach(initProduct);
    $$('[data-bundle]', root).forEach(initBundle);
    $$('[data-predictive-search]', root).forEach(initPredictiveSearch);
    $$('[data-announcement]', root).forEach(initAnnouncement);
    $$('.reels', root).forEach(initReels);
    $$('[data-recommendations]', root).forEach(initRecommendations);
    $$('[data-receipt]', root).forEach(initReceipt);
    $$('[data-product-info]', root).forEach(initProductInfo);
    initSort(root);
    initReveal(root);
  }

  function start() {
    initAll(document);
    initHeroScroll();
    setHeaderHeight();
    collapseFooterOnMobile();
    window.addEventListener('resize', setHeaderHeight, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* ------------------------------------------------------------------
     Theme editor support
  ------------------------------------------------------------------ */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    setHeaderHeight();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slider = event.target.closest('[data-slider]');
    if (!slider || !slider._goTo) return;
    if (slider._stopAutoplay) slider._stopAutoplay();
    var track = $('[data-slider-track]', slider);
    var index = Array.prototype.indexOf.call(track.children, event.target.closest('.slider-slide'));
    if (index >= 0) slider._goTo(index);
  });
})();
